import { render } from "./AreaIcon.vue?vue&type=template&id=32315421&scoped=true"
import script from "./AreaIcon.vue?vue&type=script&lang=js"
export * from "./AreaIcon.vue?vue&type=script&lang=js"

import "./AreaIcon.vue?vue&type=style&index=0&id=32315421&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32315421"]])

export default __exports__